let menuWithSAS = [];

export default {
  getList: function (menu) {
    switch (menu) {
      case 'Logistics':
        return [
          { ShortName: 'FRE', LongName: 'Freight Forwarding Management System' },
          { ShortName: 'FMS', LongName: 'Forwarding Management System' },
          { ShortName: 'HMS', LongName: 'Haulage Management System' },
          { ShortName: 'WMS', LongName: 'Warehouse Management System' },
          { ShortName: 'CON', LongName: 'Container Request & Tracking System' },
          { ShortName: 'EMS', LongName: 'Equipment Management System' },
          { ShortName: 'TRACK', LongName: 'Vehicle Tracker' },
          // { ShortName: 'CUSTPROF', LongName: 'Customer Profile' },
          { ShortName: 'MKT', LongName: 'Sales & Marketing System' },
          { ShortName: 'HRMS', LongName: 'Human Resource Management System' },
          { ShortName: 'PLT', LongName: 'Pallet Management System' },
          { ShortName: 'TMS', LongName: 'Trucking Management System' },
          { ShortName: 'FTZ', LongName: 'Free Trade Zone System' },
          { ShortName: 'VS', LongName: 'Vessel Schedule System' },
          { ShortName: 'SMK', LongName: 'Sistem Maklumat Kastam' },
          { ShortName: 'YMS', LongName: 'Yard/Depot Management System' },
          { ShortName: 'COURIER', LongName: 'Courier Management System' },
        ];
      case 'Financials':
        return [
          { ShortName: 'FINAR', LongName: 'Account Receivable' },
          { ShortName: 'Job Charges', LongName: 'Payment' },
          { ShortName: 'Invoice', LongName: 'Invoice' },
          { ShortName: 'Credit Note', LongName: 'Credit Note' },
          { ShortName: 'FINAccount', LongName: 'Account' },
          { ShortName: 'FINGL', LongName: 'General Ledger' },
          { ShortName: 'FINAdjust', LongName: 'Adjustment' },
        ];
      case 'Utilities':
        return [
          { ShortName: 'Master', LongName: 'Master Files' },
          { ShortName: 'TAS', LongName: 'Tracking & Alert System' },
          { ShortName: 'SIS', LongName: 'Standing Instruction System' },
          { ShortName: 'SAS', LongName: 'Security Access System' },
          { ShortName: 'WSA', LongName: 'Web Security Access' },
          {},
          { ShortName: 'FINARBf', LongName: 'AR Opening Balance' },
          { ShortName: 'FINAPBf', LongName: 'AP Opening Balance' },
          { ShortName: 'Fuel', LongName: 'Fuel Management System' },
          { ShortName: 'Consend', LongName: 'Container Electronic Request' },
          { ShortName: 'CUSTOMSEx', LongName: 'Download Customs Exchange' },
          { ShortName: 'UTLDA', LongName: 'Distance Analysis' },
        ];
      case 'Trading':
        return [
          { ShortName: 'IMS', LongName: 'Inventory Management System' },
          { ShortName: 'TRA', LongName: 'Trading Management System' },
        ];
    }
  },
  setSASMenus: function (menus) {
    menuWithSAS = menus;
  },
  getSASMenus: function () {
    return menuWithSAS;
  },
  getMenus: function () {
    // Left side menus
    return [
      {
        // Dashboard
        title: 'Dashboard',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-dashboard-64.png',
        items: {
          'Haulage Capacity': {
            title: 'Haulage Capacity',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/gantt.png',
            route: '/Dashboard/Haulage Capacity',
            key: 'HaulageCapacity',
            enabled: true,
            visible: true,
          },
          // 'Cust Prof': { 'title': 'Customer Profile', 'icon': 'https://img.icons8.com/bubbles/50/000000/gender-neutral-user.png', 'route': '/Logistics/CUSTPROF', 'enabled': true, 'visible': true },
          // 'Crunchie Page': { 'title': 'Crunchie Page', 'icon': 'https://img.icons8.com/cute-clipart/64/000000/nachos.png', 'route': '/Logistics/CRUNCHIE', 'enabled': true, 'visible': true },
          'Task Schedule': {
            title: 'Task Schedule',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/gantt.png',
            route: '/Dashboard/Task Schedule',
            key: 'TaskSchedule',
            enabled: true,
            visible: true,
          },
          'Job Milestones': {
            title: 'Job Milestones',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/milestone.png',
            route: '/Dashboard/Job Milestones',
            key: 'JobMilestones',
            enabled: true,
            visible: true,
          },
          'Container Throughput POL and POD': {
            title: 'Container Throughput POL and POD',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Container Throughput POL and POD',
            key: 'ContThroughputPort',
            enabled: true,
            visible: true,
          },
          'LCL Throughput POL and POD': {
            title: 'LCL Throughput POL and POD',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/LCL Throughput POL and POD',
            key: 'LCLThroughputPort',
            enabled: true,
            visible: true,
          },
          'Container Throughput': {
            title: 'Container Throughput',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Container Throughput',
            key: 'ContThroughput',
            enabled: true,
            visible: true,
          },
          'Sales Analysis': {
            title: 'Sales Analysis',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Sales Analysis',
            key: 'SalesAnalysis',
            enabled: true,
            visible: true,
          },
          'Haulage Revenue': {
            title: 'Haulage Revenue',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Haulage Revenue',
            key: 'HaulageRevenue',
            enabled: true,
            visible: true,
          },
          'Haulage Revenue by PM & Driver': {
            title: 'Haulage Revenue by PM & Driver',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Haulage Revenue by PM & Driver',
            key: 'HaulageRevByPMDriver',
            enabled: true,
            visible: true,
          },
          'Profit & Loss': {
            title: 'Profit & Loss',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Profit & Loss',
            key: 'ProfitAndLoss',
            enabled: true,
            visible: true,
          },
          'Delivery & Collection KPI': {
            title: 'Delivery & Collection KPI',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Delivery & Collection KPI',
            key: 'DelColKPI',
            enabled: true,
            visible: true,
          },
          'Document Approval': {
            title: 'Document Approval',
            icon: 'https://i.ibb.co/wMQRQRt/icons8-check-document-64-2.png',
            route: '/Dashboard/Document Approval',
            key: 'DocApproval',
            enabled: true,
            visible: true,
          },
          'Document Approval Creator': {
            title: 'Document Approval Creator',
            icon: '',
            route: '/Dashboard/Document Approval Creator',
            key: 'DocApproval',
            enabled: true,
            visible: true,
          },
          'Job Costing': {
            title: 'Job Costing',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Job Costing',
            key: 'JobCosting',
            enabled: true,
            visible: true,
          },
          'Equipment Downtime': {
            title: 'Equipment Downtime',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Equipment Downtime',
            key: 'EquipmentDowntime',
            enabled: true,
            visible: true,
          },
          'Equipment Expenses': {
            title: 'Equipment Expenses',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Equipment Expenses',
            key: 'EquipmentExpenses',
            enabled: true,
            visible: true,
          },
          'Turnaround Analysis': {
            title: 'Turnaround Analysis',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/DashboardIcons/chart.png',
            route: '/Dashboard/Turnaround Analysis',
            key: 'TurnaroundAnalysis',
            enabled: true,
            visible: true,
          },
        },
        module: 'Dashboard', // has to match the module in the URL, case sensitive
        key: 'DASHBOARD', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // Freight Forwarding
        title: 'Freight Forwarding',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-cargo-ship-64.png',
        items: {
          'Freight Booking': {
            title: 'Freight Booking',
            icon: '',
            route: '/FreightForwarding/Freight Booking',
            key: 'MnuFreightBooking',
            enabled: true,
            visible: true,
          },
          'Default Charges': {
            title: 'Default Charges',
            icon: '',
            route: '/FreightForwarding/Default Charges',
            key: 'mnuDefaultJobChrgs',
            enabled: true,
            visible: true,
          },
          'Import Job': {
            title: 'Import Job',
            icon: '',
            route: '/FreightForwarding/Import Job',
            enabled: true,
            visible: true,
          },
          'Export Job': {
            title: 'Export Job',
            icon: '',
            route: '/FreightForwarding/Export Job',
            enabled: true,
            visible: true,
          },
          'Delivery Notes': {
            title: 'Delivery Note',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-new-file-64.png',
            route: '/FreightForwarding/Delivery Notes',
            enabled: true,
            visible: true,
          },
          ROT: { title: 'ROT', icon: '', route: '/FreightForwarding/ROT', enabled: true, visible: true },
          // 'eROT': { 'title': 'eROT', 'icon': '', 'route': '/FreightForwarding/eROT', 'enabled': true, 'visible': true },
          'Freight Forwarding Report': {
            title: 'Freight Forwarding Report',
            icon: '',
            route: '/FreightForwarding/Freight Forwarding Report',
            enabled: true,
            visible: true,
          },
          'Import CIPL': {
            title: 'Import CIPL to SMK',
            icon: '',
            route: '/FreightForwarding/Import CIPL',
            enabled: true,
            visible: true,
          },
          'Status Tracking': {
            title: 'Status Tracking',
            icon: '',
            route: '/Status',
            key: 'MnuStatusTracking',
            enabled: true,
            visible: true,
          },
          
        },
        module: 'FreightForwarding', // has to match the module in the URL, case sensitive
        key: 'FMS', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // Haulage
        title: 'Haulage',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-semi-truck-64.png',
        items: {
          'Haulage Job': {
            title: 'Haulage Job',
            icon: '',
            route: '/Haulage/Haulage Job',
            key: 'mnuBooking',
            enabled: true,
            visible: true,
          },
          Consignment: { 
            title: 'Consignment', 
            icon: '', 
            route: '/Haulage/Consignment',
            key: 'mnuQuickFind',
            enabled: true, 
            visible: true 
          },
          'Vehicle Schedule': {
            title: 'Vehicle Schedule',
            icon: '',
            route: '/Haulage/Vehicle Schedule',
            key: 'mnuRadioCall',
            enabled: true,
            visible: true,
          },
          'Vehicle Tracking': {
            title: 'Vehicle Tracking',
            icon: '',
            route: '/Haulage/Vehicle Tracking',
            enabled: true,
            visible: true,
          },
          'Movement History': {
            title: 'Movement History',
            icon: '',
            route: '/Haulage/Movement History',
            enabled: true,
            visible: true,
          },
          // 'Haulage Capacity': { 'title': 'Haulage Capacity', 'icon': '', 'route': '/Haulage/Haulage Capacity', 'enabled': true, 'visible': true },
          'Movement Update': {
            title: 'Movement Update',
            icon: '',
            route: '/Haulage/Movement Update',
            key: 'mnuJIClearance',
            pageSasKey: 'CJI',
            enabled: true,
            visible: true,
          },
          'Manage': {
            title: 'Manage',
            icon: '',
            route: '/Haulage/Manage',
            key: 'mnuManage',
            pageSasKey: 'MNG',
            enabled: true,
            visible: true,
          },
          'Haulage Report': {
            title: 'Haulage Report',
            icon: '',
            route: '/Haulage/Haulage Report',
            key: 'mnuReports',
            enabled: true,
            visible: true,
          },
          'Status Tracking': {
            title: 'Status Tracking',
            icon: '',
            route: '/Status',
            key: 'mnuStatusTracking',
            enabled: true,
            visible: true,
          },
        },
        module: 'Haulage', // has to match the module in the URL, case sensitive
        key: 'HMS', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // Trucking
        title: 'Trucking',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-truck-64.png',
        items: {
          'Batch Booking': {
            title: 'Batch Booking',
            icon: '',
            route: '/Trucking/Batch Booking',
            enabled: true,
            visible: true,
          },
          'Batch Order': {
            title: 'Batch Order',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-product-documents-64.png',
            route: '/Trucking/Batch Order',
            key: 'mnuBatchOrder',
            enabled: true,
            visible: true,
          },
          'Trucking Job': {
            title: 'Trucking Job',
            icon: '',
            route: '/Trucking/Trucking Job',
            key: 'mnuBooking',
            pageSasKey: 'ORDER PROCESSING',
            enabled: true,
            visible: true,
          },
          'Plan And Assign': {
            title: 'Plan And Assign',
            icon: '',
            route: '/Trucking/Plan And Assign',
            key: '',
            enabled: true,
            visible: true,
          },
          'Vehicle Schedule': {
            title: 'Vehicle Schedule',
            icon: '',
            route: '/Trucking/Vehicle Schedule',
            enabled: true,
            visible: true,
          },
          'Trip Report': {
            title: 'Trip Report',
            icon: '',
            route: '/Trucking/Trip Report',
            enabled: true,
            visible: true,
          },
          'Trucking Report': {
            title: 'Trucking Report',
            icon: '',
            route: '/Trucking/Trucking Report',
            enabled: true,
            visible: true,
          },
          'Movement Update': {
            title: 'Movement Update',
            icon: '',
            route: '/Trucking/Movement Update',
            key: 'mnuJIClearance',
            enabled: true,
            visible: true,
          },
          'Status Tracking': {
            title: 'Status Tracking',
            icon: '',
            route: '/Status',
            key: 'mnuStatusTracking',
            enabled: true,
            visible: true,
          },
        },
        module: 'Trucking', // has to match the module in the URL, case sensitive
        key: 'TMS', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // Workshop
        title: 'Workshop',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-maintenance-64.png',
        items: {
          'Part Inventory': {
            title: 'Part Inventory',
            icon: '',
            route: '/Workshop/PartInventory',
            key: 'mnTyreStorage',
            enabled: true,
            visible: true,
          },
          'Workshop Job': {
            title: 'Workshop Job',
            icon: '',
            route: '/Workshop/WorkshopJob',
            key: 'mnJob',
            enabled: true,
            visible: true,
          },
          'Equipment Schedule': {
            title: 'Equipment Schedule',
            icon: '',
            route: '/Workshop/EquipmentSchedule',
            key: 'mnuVehicleSchedule',
            enabled: true,
            visible: true,
          },
          'Equipment Report': {
            title: 'Equipment Report',
            icon: '',
            route: '/Workshop/Equipment Report',
            enabled: true,
            visible: true,
          },
          'Policy Alerts': {
            title: 'Policy Alerts',
            icon: '',
            route: '/Workshop/Policy Alerts',
            key: 'mnuInvPolicyAlerts',
            enabled: true,
            visible: true,
          },
          'Status Tracking': {
            title: 'Status Tracking',
            icon: '',
            route: '/Status',
            key: 'mnuStatusTracking',
            enabled: true,
            visible: true,
          },
        },
        module: 'Workshop', // has to match the module in the URL, case sensitive
        key: 'EMS', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // Warehouse
        title: 'Warehouse',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-warehouse-64.png',
        items: {
          'Status Tracking': {
            title: 'Status Tracking',
            icon: '',
            route: '/Status',
            key: 'mnuStatusTracking',
            enabled: true,
            visible: true,
          }
        },
        module: '', // has to match the module in the URL, case sensitive
        key: 'WMS', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // Courier
        title: 'Courier',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-in-transit-64.png',
        items: {
          'Status Tracking': {
            title: 'Status Tracking',
            icon: '',
            route: '/Status',
            key: 'mnuStatusTracking',
            enabled: true,
            visible: true,
          },
        },
        module: '', // has to match the module in the URL, case sensitive
        key: 'COURIER', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      // { // Financials
      // 	'title': 'Financials',
      // 	'icon': 'https://dsmapi.logistics.systems/dsm6gicons/icons8-accounting-64.png',
      // 	'items': {
      // 		'Job Charges': { 'title': 'Job Charges', 'icon': 'https://dsmapi.logistics.systems/dsm6gicons/icons8-user-64.png', 'route': '/Financials/Job Charges', 'enabled': true, 'visible': true },
      // 		'FINAR': {
      // 			'icon': 'https://dsmlib.logistics.systems/Icons/icons8-receive-cash-64.png',
      // 			'key': 'FINAR',
      // 			'pages': [
      // 				{ 'title': 'Invoice', 'icon':'https://dsmlib.logistics.systems/Icons/icons8-invoice-48.png', 'route': '/Financials/FINAR/Invoice', 'visible': true },
      // 				{ 'title': 'Debit Note', 'icon':'https://dsmlib.logistics.systems/Icons/icons8-invoice_green-48.png', 'route': '/Financials/FINAR/DebitNote', 'visible': true }
      // 			]
      // 		},
      //     'FINAP': {
      // 			'icon': 'https://dsmlib.logistics.systems/Icons/icons8-invoice-64.png',
      // 			'key': 'FINPayment',
      // 			'pages': []
      // 		},
      //     'FINGL': {
      // 			'icon': 'https://dsmlib.logistics.systems/Icons/icons8-general-ledger-64.png',
      // 			'key': 'FINGL',
      // 			'pages': []
      // 		},
      //     'FINADJ': {
      // 			'icon': 'https://dsmlib.logistics.systems/Icons/icons8-replace-64.png',
      // 			'key': 'FINAdjust',
      // 			'pages': []
      // 		},
      // 	},
      // 	'key': 'FIN',
      // 	'enabled': true,
      // 	'visible': true,
      // },
      {
        // FINAR
        title: 'Financial - Account Receivables',
        icon: 'https://dsmlib.logistics.systems/Icons/account-receivable.png',
        items: {
          'Job Charges': {
            title: 'Job Charges',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-user-64.png',
            route: '/FINAR/Job Charges',
            enabled: true,
            visible: true,
          },
          Invoice: {
            title: 'Invoice',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-invoice-48.png',
            route: '/FINAR/Invoice',
            key: 'mnInvoice',
            enabled: true,
            visible: true,
          },
          'Debit Note': {
            title: 'Debit Note',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-invoice_green-48.png',
            route: '/FINAR/Debit Note',
            key: 'mnDN',
            enabled: true,
            visible: true,
          },
          'Credit Note': {
            title: 'Credit Note',
            icon: 'https://dsmlib.logistics.systems/Icons/credit-note.png',
            route: '/FINAR/Credit Note',
            visible: true,
            enabled: true,
          },
          Receipt: {
            title: 'Receipt',
            icon: 'https://dsmlib.logistics.systems/Icons/receipt-cashicons8-receipt-96.png',
            route: '/FINAR/Receipt',
            key: 'mnuRt',
            visible: true,
            enabled: true,
          },
          'Misc Receipt': {
            title: 'Misc Receipt',
            icon: 'https://dsmlib.logistics.systems/Icons/receipt-coinicons8-receipt-96 (1).png',
            route: '/FINAR/Misc Receipt',
            key: 'mnuMisc',
            visible: true,
            enabled: true,
          },
          Journal: {
            title: 'Journal',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-general-ledger-64.png',
            route: '/FINAR/Journal',
            key: 'mnuJournal',
            visible: true,
            enabled: true,
          },
          'FINAR Report': {
            title: 'FINAR Report',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-report-file-64.png',
            route: '/FINAR/FINAR Report',
            visible: true,
            enabled: true,
            key: 'FINAR Report',
            pageSasKey: 'FINAR Report',
          },
          'Statement Of Account': {
            title: 'Statement Of Account',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-cashbook-64.png',
            route: '/FINAR/Statement Of Account',
            visible: true,
            enabled: true,
            key: 'mnuStatement',
          },
          'Acknowledgement Letter': {
            title: 'Acknowledgement Letter',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-doc-64.png',
            route: '/FINAR/Acknowledgement Letter',
            visible: true,
            enabled: true,
            key: 'mnAcknowledge',
          },
          eInvoice: {
            title: 'eInvoice',
            icon: 'https://dsmlib.logistics.systems/Icons/eInvoice.png',
            route: '/FINAR/eInvoice',
            key: 'sendeinvoice',
            visible: true,
            enabled: true,
          },
          'Batch Import': {
            title: 'Batch Import',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-product-documents-64.png',
            route: '/FINAR/Batch Import',
            key: 'finarimport',
            visible: true,
            enabled: true,
          },
          'Month End': {
            title: 'Month End',
            icon: '',
            route: '/FINAR/Month End',
            key: 'mnMonthEnd',
            visible: true,
            enabled: true,
          },
        },
        module: 'FINAR', // has to match the module in the URL, case sensitive
        key: 'FINAR', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // FINAP
        title: 'Financial - Payment',
        icon: 'https://dsmlib.logistics.systems/Icons/icons8-invoice-64.png',
        items: {
          'Job Charges': {
            title: 'Job Charges',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-user-64.png',
            route: '/FINPayment/Job Charges',
            enabled: true,
            visible: true,
          },
          'AP Invoice': {
            title: 'AP Invoice',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-invoice-48.png',
            route: '/FINPayment/AP Invoice',
            enabled: true,
            visible: true,
            key: 'mnuApInv',
          },
          'AP Credit Note': {
            title: 'AP Credit Note',
            icon: 'https://dsmlib.logistics.systems/Icons/credit-note.png',
            route: '/FINPayment/AP Credit Note',
            enabled: true,
            visible: true,
            key: 'mnuAPCN',
          },
          'AP Debit Note': {
            title: 'AP Debit Note',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-invoice_green-48.png',
            route: '/FINPayment/AP Debit Note',
            enabled: true,
            visible: true,
            key: 'mnuAPDN',
          },
          Payment: {
            title: 'Payment',
            icon: 'https://dsmlib.logistics.systems/Icons/Payment.png',
            route: '/FINPayment/Payment',
            enabled: true,
            visible: true,
            key: 'mnuPayment',
          },
          'Purchase Requisition': {
            title: 'Purchase Requisition',
            icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-row-64.png',
            route: '/FINPayment/PurchaseRequisition',
            enabled: true,
            visible: true,
          },
          'Purchase Order': {
            title: 'Purchase Order',
            icon: 'https://dsmlib.logistics.systems/Icons/Ready.png',
            route: '/FINPayment/PurchaseOrder',
            enabled: true,
            visible: true,
            key: 'mnuPO',
          },
          'Creditor Ageing': {
            title: 'Creditor Ageing',
            icon: '',
            route: '/FINPayment/Creditor Ageing',
            enabled: true,
            visible: true,
            key: 'mnuAgeing',
          },
          'Month End': {
            title: 'Month End',
            icon: '',
            route: '/FINPayment/Month End',
            key: 'mnMonthEnd',
            visible: true,
            enabled: true,
          },
        },
        module: 'FINPayment', // has to match the module in the URL, case sensitive
        key: 'FINPayment', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // FINAC
        title: 'Financial - Account',
        icon: 'https://dsmlib.logistics.systems/Icons/icons8-cashbook-64.png',
        items: {
          Cheque: {
            title: 'Cheque',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-user-64.png',
            route: '/FINAccount/Cheque',
            key: 'mnuCheque',
            enabled: true,
            visible: true,
          },
          'Bank Reconciliation': {
            title: 'Bank Reconciliation',
            icon: '',
            route: '/FINAccount/Bank Reconciliation',
            enabled: true,
            visible: true,
          },
          'Month End': {
            title: 'Month End',
            icon: '',
            route: '/FINAccount/Month End',
            key: 'mnMonthEnd',
            visible: true,
            enabled: true,
          },
        },
        module: 'FINAccount', // has to match the module in the URL, case sensitive
        key: 'FINAccount', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // FINGL
        title: 'Financial - General Ledger',
        icon: 'https://dsmlib.logistics.systems/Icons/icons8-general-ledger-64.png',
        items: {
          Enquiries: {
            title: 'Enquiries',
            icon: '',
            route: '/FINGL/Enquiries',
            key: 'mnEquiries',
            enabled: true,
            visible: true,
          },
          'HQ Consolidated': {
            icon: '',
            key: 'mnuHQConsolidatedAccts',
            pages: [
              {
                title: 'Profit & Loss',
                icon: '',
                route: '/FINGL/HQConsolidated/HQConsolidatedProfitLoss',
                key: 'mnuHQPNL',
                enabled: true,
                visible: true,
              },
              {
                title: 'Enquiries',
                icon: '',
                route: '/FINGL/HQConsolidated/HQConsolidatedEnquiries',
                key: 'mnuHQEnquiries',
                enabled: true,
                visible: true,
              },
            ],
          },
          'SST Return (SST02)': {
            title: 'SST Return',
            icon: '',
            route: '/FINGL/SSTReturn',
            key: 'mnuSSTReturn',
            enabled: true,
            visible: true,
          },
          'Journal': {
            title: 'Journal Entry',
            icon: '',
            route: '/FINGL/Journal Entry',
            key: 'mnuJournal',
            enabled: true,
            visible: true,
          },
          'Month End': {
            title: 'Month End',
            icon: '',
            route: '/FINGL/Month End',
            key: 'mnuME',
            visible: true,
            enabled: true,
          },
          'Validation': {
            title: 'Validation',
            icon: '',
            route: '/FINGL/Validation',
            key: 'mnuValidateAccounts',
            visible: true,
            enabled: true,
          },
          'Generate New Year': {
            title: 'Generate New Year',
            icon: '',
            route: '/FINGL/Generate New Year',
            key: 'mnuNewYear',
            visible: true,
            enabled: true,
          },
          'FINGL Reports': {
            title: 'FINGL Reports',
            icon: '',
            route: '/FINGL/FINGL Reports',
            key: 'mnuRP',
            enabled: true,
            visible: true,
          },
        },
        module: 'FINGL', // has to match the module in the URL, case sensitive
        key: 'FINGL', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // FINADJ
        title: 'Financial - Adjustment',
        icon: 'https://dsmlib.logistics.systems/Icons/icons8-replace-64.png',
        items: {
          'Refund Note': {
            title: 'Refund Note',
            icon: '',
            route: '/FINADJ/Refund Note',
            key: '',
            enabled: true,
            visible: true,
          },
        },
        module: '', // has to match the module in the URL, case sensitive
        key: 'FINAdjust', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // Master Files
        title: 'Master Files',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-product-documents-64.png',
        items: {
          'Profile Master': {
            icon: 'https://dsmlib.logistics.systems/Icons/ProfileMaster.png',
            key: '',
            pages: [
              // { 'title': 'Shipper/Consignee', 'icon': '', 'route': '/ShipperConsignee', 'enabled': true, 'visible': true },
              // { 'title': 'Debtor', 'icon': 'https://img.icons8.com/nolan/64/debt.png', 'route': '/Debtor', 'enabled': true, 'visible': true },
              // { 'title': 'Vendor/Supplier', 'icon': '', 'route': '/VendorSupplier', 'enabled': true, 'visible': true },
              // { 'title': 'Creditor', 'icon': '', 'route': '/Creditor', 'enabled': true, 'visible': true },
              // { 'title': 'Dealer', 'icon': '', 'route': '/Dealer', 'enabled': true, 'visible': true },
              // { 'title': 'Employee', 'icon': '', 'route': '/Employee', 'enabled': true, 'visible': true },
              {
                title: 'Customer',
                icon: '',
                route: '/MasterFiles/ProfileMaster/Customer',
                key: 'cmdMaster_6',
                enabled: true,
                visible: true,
              },
              {
                title: 'Shipper/Consignee',
                icon: 'https://dsmlib.logistics.systems/Icons/ShipperConsignee.png',
                route: '/MasterFiles/ProfileMaster/ShipperConsignee',
                key: 'cmdMaster_8',
                enabled: true,
                visible: true,
              },
              {
                title: 'Creditor',
                icon: '',
                route: '/MasterFiles/ProfileMaster/Creditor',
                enabled: true,
                visible: true,
              },
              {
                title: 'Supplier',
                icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-supplier-64.png',
                route: '/MasterFiles/ProfileMaster/Supplier',
                enabled: true,
                visible: true,
              },
              {
                title: 'Employee',
                icon: 'https://dsmlib.logistics.systems/Icons/Employee.png',
                route: '/MasterFiles/ProfileMaster/Employee',
                key: 'cmdMaster_12',
                enabled: true,
                visible: true,
              },
            ],
          },
          'Operation Master': {
            icon: 'https://dsmlib.logistics.systems/Icons/OperationMaster.png',
            key: '',
            pages: [
              // { 'title': 'Zone', 'icon': '', 'route': '/Zone', 'enabled': true, 'visible': true },
              // { 'title': 'Tariff Area & Rate', 'icon': '', 'route': '/TariffAreaRate', 'enabled': true, 'visible': true },
              {
                title: 'Container Type',
                icon: 'https://dsmlib.logistics.systems/Icons/ContainerType.png',
                route: '/MasterFiles/OperationMaster/ContainerType',
                key: 'cmdMaster_25',
                enabled: true,
                visible: true,
              },
              {
                title: 'Cont Delivery Type',
                icon: 'https://dsmlib.logistics.systems/Icons/ContDeliveryType.png',
                route: '/MasterFiles/OperationMaster/ContDeliveryType',
                key: 'cmdMaster_26',
                pageSasKey: 'Container Delivery Type',
                enabled: true,
                visible: true,
              },
              {
                title: 'Cont Handling Type',
                icon: 'https://dsmlib.logistics.systems/Icons/ContainerHandling.png',
                route: '/MasterFiles/OperationMaster/ContHandlingType',
                key: 'cmdMaster_27',
                pageSasKey: 'Container Handling Type',
                enabled: true,
                visible: true,
              },
              {
                title: 'Cargo Type',
                icon: 'https://dsmlib.logistics.systems/Icons/CargoType.png',
                route: '/MasterFiles/OperationMaster/CargoType',
                key: 'cmdMaster_28',
                enabled: true,
                visible: true,
              },
              {
                title: 'Destination',
                icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-place-marker-64.png',
                route: '/MasterFiles/OperationMaster/Destination',
                key: 'cmdMaster_20',
                enabled: true,
                visible: true,
              },
              {
                title: 'Zone',
                icon: 'https://dsmlib.logistics.systems/Icons/icons8-country-100.png',
                route: '/MasterFiles/OperationMaster/Zone',
                enabled: true,
                visible: true,
              },
              {
                title: 'Port',
                icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-location-64.png',
                route: '/MasterFiles/OperationMaster/Port',
                key: 'cmdMaster_68',
                enabled: true,
                visible: true,
              },
              {
                title: 'Vehicle',
                icon: 'https://dsmlib.logistics.systems/Icons/SteeringWheel.png',
                route: '/MasterFiles/OperationMaster/Vehicle',
                enabled: true,
                visible: true,
              },
              {
                title: 'Vehicle Category',
                icon: '',
                route: '/MasterFiles/OperationMaster/VehicleCategory',
                key: 'cmdMaster_102',
                enabled: true,
                visible: true,
              },
              {
                title: 'Vehicle Team',
                icon: '',
                route: '/MasterFiles/OperationMaster/VehicleTeam',
                key: 'cmdMaster_105',
                enabled: true,
                visible: true,
              },
              {
                title: 'Vehicle Ownership',
                icon: '',
                route: '/MasterFiles/OperationMaster/VehicleOwnership',
                key: 'cmdMaster_88',
                enabled: true,
                visible: true,
              },
              {
                title: 'EMS Part Type',
                icon: '',
                route: '/MasterFiles/OperationMaster/EMSPartType',
                key: 'cmdMaster_101',
                enabled: true,
                visible: true,
              },
              {
                title: 'Warehouse Product',
                icon: '',
                route: '/MasterFiles/OperationMaster/WarehouseProduct',
                key: 'cmdMaster_30',
                enabled: true,
                visible: true,
              },
              {
                title: 'Commodity',
                icon: '',
                route: '/MasterFiles/OperationMaster/Commodity',
                key: 'cmdMaster_33',
                enabled: true,
                visible: true,
              },
              {
                title: 'Service Code',
                icon: '',
                route: '/MasterFiles/OperationMaster/ServiceCode',
                key: 'cmdMaster_104',
                enabled: true,
                visible: true,
              },
              {
                title: 'Item Type',
                icon: '',
                route: '/MasterFiles/OperationMaster/ItemType',
                key: 'cmdMaster_76',
                enabled: true,
                visible: true,
              },
              // { 'title': 'Distance', 'icon': '', 'route': '/Distance', 'enabled': true, 'visible': true },
              // { 'title': 'Haulier Charges', 'icon': '', 'route': '/HaulierCharges', 'enabled': true, 'visible': true },
              // { 'title': 'Other Charges', 'icon': '', 'route': '/OtherCharges', 'enabled': true, 'visible': true },
              // { 'title': 'Bill Rate', 'icon': '', 'route': '/BillRate', 'enabled': true, 'visible': true },
              // { 'title': 'SMK Product', 'icon': '', 'route': '/SMKProduct', 'enabled': true, 'visible': true },
              // { 'title': 'SMK Item', 'icon': '', 'route': '/SMKItem', 'enabled': true, 'visible': true },
              // { 'title': 'SMK Exemption', 'icon': '', 'route': '/SMKExemption', 'enabled': true, 'visible': true },
              // { 'title': 'SMK Warehouse', 'icon': '', 'route': '/SMKWarehouse', 'enabled': true, 'visible': true },
              // { 'title': 'Container Type', 'icon': '', 'route': '/ContainerType', 'enabled': true, 'visible': true },
              // { 'title': 'Cont Delivery Type', 'icon': '', 'route': '/ContDeliveryType', 'enabled': true, 'visible': true }
            ],
          },
          'Accounting Master': {
            icon: 'https://dsmlib.logistics.systems/Icons/AccountingMaster.png',
            key: '',
            pages: [
              {
                title: 'Bank',
                icon: '',
                route: '/MasterFiles/AccountingMaster/Bank',
                key: 'cmdMaster_48',
                pageSasKey: 'BANK CODE',
                enabled: true,
                visible: true,
              },
              {
                title: 'Charge Code',
                icon: '',
                route: '/MasterFiles/AccountingMaster/ChargeCode',
                key: 'cmdMaster_38',
                pageSasKey: 'CHARGES CODE',
                enable: true,
                visible: true,
              },
              {
                title: 'GL Master',
                icon: '',
                route: '/MasterFiles/AccountingMaster/GLMaster',
                key: 'cmdMaster_39',
                pageSasKey: 'GL MASTER',
                enabled: true,
                visible: true,
              },
              {
                title: 'Transaction Group',
                icon: '',
                route: '/MasterFiles/AccountingMaster/TransactionGroup',
                key: 'cmdMaster_53',
                enable: true,
                visible: true,
              },
            ],
          },
          'Common Master': {
            icon: 'https://dsmlib.logistics.systems/Icons/CommonMaster.png',
            key: '',
            pages: [
              {
                title: 'Company',
                icon: '',
                route: '/MasterFiles/CommonMaster/Company',
                key: 'cmdMaster_54',
                enabled: true,
                visible: true,
              },
              {
                title: 'Document',
                icon: '',
                route: '/MasterFiles/CommonMaster/Document',
                key: 'cmdMaster_56',
                enabled: true,
                visible: true,
              },
              {
                title: 'Sales Team',
                icon: '',
                route: '/MasterFiles/CommonMaster/Sales Team',
                key: 'cmdMaster_57',
                enabled: true,
                visible: true,
              },
              {
                title: 'Service Team',
                icon: '',
                route: '/MasterFiles/CommonMaster/Service Team',
                key: 'cmdMaster_58',
                enabled: true,
                visible: true,
              },
              {
                title: 'Status Code',
                icon: '',
                route: '/MasterFiles/CommonMaster/StatusCode',
                key: 'cmdMaster_60',
                enabled: true,
                visible: true,
              },
              {
                title: 'Status Group',
                icon: '',
                route: '/MasterFiles/CommonMaster/StatusGroup',
                key: 'cmdMaster_61',
                enabled: true,
                visible: true,
              },
              {
                title: 'Status List Category',
                icon: '',
                route: '/MasterFiles/CommonMaster/StatusListCategory',
                key: 'cmdMaster_128',
                enabled: true,
                visible: true,
              },
              {
                title: 'Default Status List',
                icon: '',
                route: '/MasterFiles/CommonMaster/DefaultStatusList',
                key: 'cmdMaster_129',
                enabled: true,
                visible: true,
              },
              {
                title: 'Country',
                icon: '',
                route: '/MasterFiles/CommonMaster/Country',
                key: 'cmdMaster_63',
                enabled: true,
                visible: true,
              },
              {
                title: 'Exchange Rate',
                icon: '',
                route: '/MasterFiles/CommonMaster/ExchangeRate',
                key: 'cmdMaster_65',
                enabled: true,
                visible: true,
              },
              {
                title: 'SMK Exchange Rate',
                icon: '',
                route: '/MasterFiles/CommonMaster/SMKExchangeRate',
                key: 'cmdMaster_66',
                enabled: true,
                visible: true,
              },
              {
                title: 'Station',
                icon: '',
                route: '/MasterFiles/CommonMaster/Station',
                key: 'cmdMaster_69',
                enabled: true,
                visible: true,
              },
            ],
          },
          'Rates Master': {
            icon: 'https://dsmlib.logistics.systems/Icons/RatesMaster.png',
            key: '',
            pages: [
              {
                title: 'Trucking Rate',
                icon: '',
                route: '/MasterFiles/RatesMaster/TruckingRate',
                key: 'cmdMaster_19',
                enable: true,
                visible: true,
              },
              {
                title: 'Bill Rate Others',
                icon: '',
                route: '/MasterFiles/RatesMaster/BillRateOthers',
                key: 'cmdMaster_93',
                enable: true,
                visible: true,
              },
              {
                title: 'Tariff Rate',
                icon: 'https://dsmlib.logistics.systems/Icons/icons8-expensive-100.png',
                route: '/MasterFiles/RatesMaster/TariffRate',
                key: 'cmdMaster_19',
                enabled: true,
                visible: true,
              },
              {
                title: 'Quotation',
                icon: '',
                route: '/FreightForwarding/Default Charges',
                enabled: true,
                visible: true,
              },
              {
                title: 'Container Rate',
                icon: '',
                route: '/MasterFiles/RatesMaster/ContainerRate',
                key: 'cmdMaster_22',
                pageSasKey: 'HAULIER CHARGES',
                enabled: true,
                visible: true,
              },
              {
                title: 'Haulage Rate',
                icon: '',
                route: '/MasterFiles/RatesMaster/HaulageRate',
                key: 'cmdMaster_23',
                enabled: true,
                visible: true,
              },
            ],
          },
        },
        module: 'MasterFiles', // has to match the module in the URL, case sensitive
        key: 'MASTER', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
      {
        // Settings
        title: 'Settings',
        icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-settings-64.png',
        items: {
          'User Management': {
            title: 'User Management',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-user-64.png',
            route: '/Settings/User Management',
            key: 'CMDMNGUSERS',
            enabled: true,
            visible: true,
          },
          'Role Management': {
            title: 'Role Management',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-user-64.png',
            route: '/Settings/Role Management',
            key: 'CMDMNGUSERS',
            enabled: true,
            visible: true,
          },
          'User Options': {
            title: 'User Options',
            icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-admin-settings-male-64.png',
            route: '/Settings/User Options',
            key: 'mnuUserOptions',
            enabled: true,
            visible: true,
          },
          'Report Designer': {
            title: 'Report Designer',
            icon: 'https://121.121.40.185:89/dsm6gicons/icons8-report-file-64.png',
            route: '/Settings/Report Designer',
            enabled: true,
            visible: true,
          },
          'Report Designer V2': {
            title: 'Report Designer V2',
            icon: 'https://121.121.40.185:89/dsm6gicons/icons8-report-file-64.png',
            route: '/Settings/Report Designer V2',
            key: 'cmdDesignReport',
            enabled: true,
            visible: true,
          },
          'Report Designer V3': {
            title: 'Report Designer V3',
            icon: 'https://121.121.40.185:89/dsm6gicons/icons8-report-file-64.png',
            route: '/Settings/Report Designer V3',
            enabled: true,
            visible: true,
          },
          'SMK Message Tracking': {
            title: 'SMK Message Tracking',
            icon: '',
            route: '/Settings/SMK Message Tracking',
            enabled: true,
            visible: true,
          },
          'Broadcast Message': {
            title: 'Broadcast Message',
            icon: '',
            route: '/Settings/Broadcast Message',
            enabled: true,
            visible: true,
          },
        },
        module: 'Settings', // has to match the module in the URL, case sensitive
        key: 'SAS', // sent to the GetSASControlAccess API
        enabled: true,
        visible: true,
      },
    ];
  },
};
